import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="yu-baby-message-load-more-callback"
export default class extends Controller {
  static outlets = ['yu-baby']

  connect() {
    this.yuBabyOutlet.returnToFirstBeforeLoadMessage()
    this.element.remove()
  }
}
